import { NavLink, Outlet } from 'react-router-dom';
import { LayoutDashboard, Users, Star, Settings2, History, MessageSquare } from 'lucide-react';

const PRO_TABS = [
  { to: '/profissional/portal',        label: 'Portal',        Icon: LayoutDashboard },
  { to: '/profissional/clientes',      label: 'Clientes',      Icon: Users },
  { to: '/profissional/gerar-analise', label: 'Gerar Análise', Icon: Star },
  { to: '/profissional/historico',     label: 'Histórico',     Icon: History },
  { to: '/profissional/configuracoes', label: 'Config.',       Icon: Settings2 },
  { to: '/profissional/feedback',      label: 'Feedback',      Icon: MessageSquare },
];

export function ProfessionalLayout() {
  return (
    <div style={{ paddingTop: '1rem' }}>
      {/* Tab bar */}
      <div style={{
        display: 'flex',
        gap: 0,
        marginBottom: '1.5rem',
        borderBottom: '2px solid var(--border-subtle)',
        overflowX: 'auto',
        scrollbarWidth: 'none',
      }}>
        {PRO_TABS.map(({ to, label, Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/profissional/portal'}
            style={({ isActive }) => ({
              display: 'flex',
              alignItems: 'center',
              gap: '0.375rem',
              padding: '0.625rem 1rem',
              fontSize: 'var(--text-caption)',
              fontWeight: 500,
              whiteSpace: 'nowrap',
              color: isActive ? 'var(--petrol)' : 'var(--text-secondary)',
              borderBottom: isActive ? '2px solid var(--petrol)' : '2px solid transparent',
              marginBottom: '-2px',
              textDecoration: 'none',
              transition: 'color 150ms, border-color 150ms',
              flexShrink: 0,
            })}
          >
            <Icon size={14} aria-hidden />
            {label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
